import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const API_BASE = API;

// ---------- public ----------
export const createBooking = (data) =>
  axios.post(`${API}/bookings`, data).then((r) => r.data);

export const sendMessage = (data) =>
  axios.post(`${API}/contact`, data).then((r) => r.data);

export const fetchTestimonials = () =>
  axios.get(`${API}/testimonials`).then((r) => r.data);

export const submitTestimonial = (data) =>
  axios.post(`${API}/testimonials`, data).then((r) => r.data);

export const fetchContent = () => axios.get(`${API}/content`).then((r) => r.data);
export const fetchArtworks = () => axios.get(`${API}/artworks`).then((r) => r.data);
export const fetchPricing = () => axios.get(`${API}/pricing`).then((r) => r.data);

export const fetchAvailabilityMonth = (year, month) =>
  axios.get(`${API}/availability/month`, { params: { year, month } }).then((r) => r.data);
export const fetchAvailabilityDay = (date) =>
  axios.get(`${API}/availability/day`, { params: { date } }).then((r) => r.data);

export const startCheckout = (payload) =>
  axios
    .post(`${API}/payments/checkout`, { ...payload, origin_url: window.location.origin })
    .then((r) => r.data);

export const fetchPaymentStatus = (sessionId) =>
  axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);

// ---------- helpers ----------
export const formatPrice = (p) => {
  if (p === null || p === undefined || p === "") return "Inquire";
  const n = Number(p);
  if (Number.isNaN(n)) return String(p);
  return `$${n.toLocaleString(undefined, { minimumFractionDigits: Number.isInteger(n) ? 0 : 2 })}`;
};

// ---------- admin (token auth) ----------
const TOKEN_KEY = "dda_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const adminLogin = (username, password) =>
  axios.post(`${API}/auth/login`, { username, password }).then((r) => r.data);
export const adminMe = () => adminApi.get(`/auth/me`).then((r) => r.data);

export const adminUpload = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return adminApi
    .post(`/admin/upload`, fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

export const adminCreateArtwork = (d) => adminApi.post(`/admin/artworks`, d).then((r) => r.data);
export const adminUpdateArtwork = (id, d) => adminApi.put(`/admin/artworks/${id}`, d).then((r) => r.data);
export const adminDeleteArtwork = (id) => adminApi.delete(`/admin/artworks/${id}`).then((r) => r.data);

export const adminUpdateContent = (d) => adminApi.put(`/admin/content`, d).then((r) => r.data);

export const adminCreatePricing = (d) => adminApi.post(`/admin/pricing`, d).then((r) => r.data);
export const adminUpdatePricing = (id, d) => adminApi.put(`/admin/pricing/${id}`, d).then((r) => r.data);
export const adminDeletePricing = (id) => adminApi.delete(`/admin/pricing/${id}`).then((r) => r.data);

export const adminListTestimonials = () => adminApi.get(`/admin/testimonials`).then((r) => r.data);
export const adminCreateTestimonial = (d) => adminApi.post(`/admin/testimonials`, d).then((r) => r.data);
export const adminUpdateTestimonial = (token, d) => adminApi.put(`/admin/testimonials/${token}`, d).then((r) => r.data);
export const adminDeleteTestimonial = (token) => adminApi.delete(`/admin/testimonials/${token}`).then((r) => r.data);

// availability (admin)
export const adminGetAvailability = () => adminApi.get(`/admin/availability`).then((r) => r.data);
export const adminSetRecurring = (rules) => adminApi.put(`/admin/availability/recurring`, { rules }).then((r) => r.data);
export const adminSetOverride = (d) => adminApi.post(`/admin/availability/override`, d).then((r) => r.data);
export const adminDeleteOverride = (id) => adminApi.delete(`/admin/availability/override/${id}`).then((r) => r.data);

// inbox (admin)
export const adminInboxBookings = () => adminApi.get(`/admin/inbox/bookings`).then((r) => r.data);
export const adminInboxMessages = () => adminApi.get(`/admin/inbox/messages`).then((r) => r.data);
export const adminReadBooking = (ref, read) => adminApi.patch(`/admin/inbox/bookings/${ref}`, { read }).then((r) => r.data);
export const adminDeleteBooking = (ref) => adminApi.delete(`/admin/inbox/bookings/${ref}`).then((r) => r.data);
export const adminReadMessage = (id, read) => adminApi.patch(`/admin/inbox/messages/${id}`, { read }).then((r) => r.data);
export const adminDeleteMessage = (id) => adminApi.delete(`/admin/inbox/messages/${id}`).then((r) => r.data);


export const apiErr = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || fallback;
  return fallback;
};
